import React from "react";
import bg_image from "../../assets/images/About page headers-01.jpg";
import bg_M_image from "../../assets/images/About page  headers Mobilescreen-01.jpg";
const AboutBanner = () => {
  return (
  <div className=" w-full xl:bg-fixed relative mx-auto  overflow-hidden flex items-center justify-center">
      {/* Content */}
      <div className="w-full">
        <img src={bg_image} alt="" className="w-full  h-auto hidden xl:block " />
        <img src={bg_M_image} alt="" className="w-full  h-auto  block xl:hidden " />
      </div>
    </div>
  );
};
export default AboutBanner;
